import {
  AccredibleResponsiveBreakpoint,
  AccredibleResponsiveHelper,
} from '@accredible-frontend-v2/utils/responsive-helper';
import { ChangeDetectionStrategy, Component, HostListener } from '@angular/core';

@Component({
  standalone: true,
  selector: 'accredible-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent {
  isDesktop = AccredibleResponsiveHelper.isScreenGreaterThan(AccredibleResponsiveBreakpoint.MD);

  @HostListener('window:resize')
  onResize(): void {
    this.isDesktop = AccredibleResponsiveHelper.isScreenGreaterThan(
      AccredibleResponsiveBreakpoint.MD,
    );
  }
}
